import { BsXLg } from "react-icons/bs";
import css from "./ModalCloseIcon.module.css";

export default function ModalCloseIcon({ onClose, ...rest }) {
  return <BsXLg className={css.closeIcon} onClick={onClose} {...rest} />;
}
